module.exports = __webpack_public_path__ + "b3cfd9a455c8f2c8ba6310ef9bb9361b.MP3";